import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createSlots as _createSlots, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "dialog"
};
const _hoisted_2 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");

  const _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    modelValue: $setup.visible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.visible = $event),
    title: $props.dialogTitle,
    "before-close": $setup.closeDialog,
    "destroy-on-close": ""
  }, _createSlots({
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "dialog-content")]),
    _: 2
  }, [$props.hasDialogFooter ? {
    name: "footer",
    fn: _withCtx(() => [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.btns, btn => {
      return _openBlock(), _createBlock(_component_el_button, {
        key: btn.label,
        type: btn.btnType,
        onClick: $event => $setup.handleClick(btn.key)
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(btn.label), 1)]),
        _: 2
      }, 1032, ["type", "onClick"]);
    }), 128))])])
  } : undefined]), 1032, ["modelValue", "title", "before-close"])]);
}